var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTop3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1440 320",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    fillOpacity: 1,
    d: "M 0 183 L 0 183 C 60 203 118 198 180 181.3 C 240 163 300 128 360 101.3 C 420 75 480 53 540 37.3 C 600 21 660 11 720 10.7 C 780 11 840 21 900 53.3 C 960 85 1020 135 1080 154.7 C 1138 175 1202 176 1259 166 C 1326 155 1366 103 1439 126 L 1448 129 L 1440 0 L 1410 0 C 1380 0 1320 0 1260 0 C 1200 0 1140 0 1080 0 C 1020 0 960 0 900 0 C 840 0 780 0 720 0 C 660 0 600 0 540 0 C 480 0 420 0 360 0 C 300 0 240 0 180 0 C 120 0 60 0 30 0 L 0 0 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTop3);
export default __webpack_public_path__ + "static/media/top3.2330d69b.svg";
export { ForwardRef as ReactComponent };